import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { FaHandPointRight, FaPrint, } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { ACADEMIC_YEAR, CONTEXT_NAME } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

export const Afterprint = () =>
    <div id='afterprint'>
        <Row style={{ textAlign: "center", justifyContent: "center", borderBottom: "2px solid black" }}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <h3 className="heading" style={{ fontWeight: "bold", fontSize: "25px" }}>
                    {CONTEXT_NAME} - {ACADEMIC_YEAR}
                </h3>
                <h5 style={{ fontSize: "15px" }}>GOVERNMENT OF ANDHRA PRADESH</h5>
            </Col>
        </Row>
    </div>
export const PersonalDetails = (props) => {
    const { showData } = props;
    return (<>
        <div className='personal-block'>
            <div className="personal-head mt-3">
                <span>Personal Details</span>
            </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped" style={{ tableLayout: 'fixed' }}>
                        <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                            <tr>
                                <td style={{ width: '15%' }}>Candidate Id </td>
                                <th style={{ width: '20%' }}>{showData?.candidate_id}</th>
                                <td style={{ width: '15%' }}>Aadhaar No. </td>
                                <th style={{ width: '20%' }}>{showData?.aadhaar_no}</th>
                                <td rowSpan={4} className="" style={{ width: '30%' }}>
                                    <img src={showData?.img_path ? config.url.FILE_DOWNLOAD_URL + showData?.img_path : '#'}
                                        className='img-fluid'
                                        alt="studentphoto"
                                        style={{
                                            width: "130px",
                                            height: "150px",
                                            display: "block",
                                            margin: "0 auto",
                                            border: "1px solid #ddd"
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Applicant Name</td>
                                <th>{showData?.applicant_name}</th>
                                <td>Mobile No.</td>
                                <th>{showData?.mobile_no}</th>
                            </tr>
                            <tr>
                                <td>Application Date </td>
                                <th>{showData?.last_applied_on ? showData?.last_applied_on : showData?.appl_confirmed_on ? showData?.appl_confirmed_on : '-'}</th>
                                <td>Date of Birth (DD/MM/YYYY)</td>
                                <th>{moment(showData?.dob).format('DD-MM-YYYY')}</th>
                            </tr>
                            <tr>
                                <td>Father's Name</td>
                                <th>{showData?.father_name}</th>
                                <td>Mother's Name</td>
                                <th>{showData?.mother_name}</th>
                            </tr>
                            <tr>
                                <td>Gender</td>
                                <th>{showData?.gender}, {showData?.marital_status}</th>
                                <td>Caste</td>
                                <th colSpan={2}>{showData?.caste}, &nbsp;
                                    {showData?.is_ews === true && showData?.caste === 'OC' ? "Eligible for (EWS)" : "Not Eligible for (EWS)"}
                                </th>
                            </tr>
                            <tr> <td>Ex-Service Woman</td>
                                <th>{showData?.is_ex_service_men === true ? <>Yes ,{showData?.ex_service}</> : "No"}</th>
                                <td>E-mail</td>
                                <th colSpan={2}>{showData?.email}</th>
                            </tr>
                            <tr>
                                <td>If Differently Abled(PH)</td>
                                <th colSpan={4}>{showData?.is_ph === true ? <React.Fragment>
                                    {showData?.is_vh === true && <React.Fragment>VISUALLY IMPAIRED(VI)  - {showData?.vh_percentage}%</React.Fragment>}<br />
                                    {showData?.is_hi === true && <React.Fragment>HEARING IMPAIRED(HI)  - {showData?.hi_percentage}%</React.Fragment>}<br />
                                    {showData?.is_oh === true && <React.Fragment>ORTHOPEDICALLY HANDICAPPED(OH)  - {showData?.oh_percentage}%</React.Fragment>}<br />
                                    {showData?.is_mi === true && <React.Fragment>MENTAL DISABILITY / MULTIPLE DISABILITY(MD)  : {showData?.mi_percentage}%</React.Fragment>}

                                 
                                </React.Fragment> : 'No'}
                                </th>
                            </tr>
                            <tr>
                                <td>Communication Details</td>
                                <th colSpan={2}>{showData?.is_andhra === true ? <React.Fragment>
                                    {showData?.address}, Door No.{showData?.door_no},&nbsp;
                                    {showData?.village_name} {showData?.mandal_name}-{showData?.pin_code},&nbsp;
                                    {showData?.dist_name} dist.
                                </React.Fragment> :
                                    <React.Fragment>
                                        {showData?.address}, Door No.{showData?.door_no},&nbsp;
                                        {showData?.mandal_name} - {showData?.pin_code},&nbsp;
                                        {showData?.dist_name} dist., {showData?.state_name}
                                    </React.Fragment>}</th>
                              <td></td>
                              <th></th>

                            </tr>
                            {/* <tr>
                                    <td colSpan={3}>Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014 <br />and are you claiming under the G.O MS No 133:</td>
                                    <th colSpan={2}>{showData?.is_telangana === true ? <React.Fragment>Yes, {showData?.claiming_district_name} District.</React.Fragment> : 'No'} </th>
                                </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </>)
}
export const SevenYearDetails = (props) => {
    const { showSevenData,showData } = props;
    return (<> <div className='personal-block'>
        <div className="personal-head mt-1">
            <span>Basic Education Details</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3">
                <table className="table table-bordered table-striped"
                    style={{
                        borderCollapse: 'collapse',
                        width: '100%',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                            <th style={{ width: '25%' }}>District</th>
                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                            <th style={{ width: '25%' }}>District</th>
                        </tr>
                        <tr>
                            <td>{showSevenData[0]?.class_no}<sup>Th</sup>Class </td>
                            <td>{showSevenData[0]?.dist_name}</td>
                            <td>{showSevenData[1]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[1]?.dist_name}</td>
                        </tr>
                        <tr>
                            <td>{showSevenData[2]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[2]?.dist_name}</td>
                            <td>{showSevenData[3]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[3]?.dist_name}</td>
                        </tr>
                        <tr>
                            <td>{showSevenData[4]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[4]?.dist_name}</td>
                            <td>{showSevenData[5]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[5]?.dist_name}</td>
                        </tr>

                        <tr>
                            <td>{showSevenData[6]?.class_no}<sup>Th</sup>Class</td>
                            <td>{showSevenData[6]?.dist_name}</td>
                            <td colSpan={2}></td>
                        </tr>
                        {showData?.is_telangana === true && <tr><td colSpan={2}>Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014
                            and are you claiming under the G.O MS No 133:</td>
                            <th>{showData?.is_telangana === true ? <React.Fragment>Yes.</React.Fragment> : 'No'}</th></tr>
                        }
                        <tr><td>Local District</td>
                            <th colSpan={3}>{showData?.is_telangana === true ? showData?.claiming_district_name : showData?.local_dist_name}</th></tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div></>)
}
export const SSCDetails = (props) => {
    const { showSSCInterData } = props;
    return (<>  <div className='personal-block'>
        <div className="personal-head mt-1">
            <span>SSC or its Equivalent Qualifications:</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3">
                <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th>Board</th>
                            <th>Medium</th>
                            <th>1st Language</th>
                            <th>Year of Passing</th>
                            <th>Total Marks</th>
                            <th>Marks Secured</th>
                            <th>% of Marks</th>
                            <th>Hall Ticket No.</th>
                            <th>Did you studied English ?</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>{showSSCInterData?.ssc_board_name}</td>
                            <td>{showSSCInterData?.ssc_medium_name}</td>
                            <td>{showSSCInterData?.ssc_first_language_name}</td>
                            <td>{showSSCInterData?.ssc_year_of_pass}</td>
                            <td>{showSSCInterData?.ssc_total_marks}</td>
                            <td>{showSSCInterData?.ssc_marks_secured}</td>  
                            <td>{showSSCInterData?.ssc_percentage}</td>
                            <td>{showSSCInterData?.ssc_hall_ticket}</td>
                            <td>{showSSCInterData?.is_english_ssc === true ? 'Yes' : 'No'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </>)
}
export const INTERDetails = (props) => {
    const { showSSCInterData } = props;
    return (<> <div className='personal-block'>
        <div className="personal-head mt-1">
            <span>Intermediate or its Equivalent Qualification:</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3">
                <table className="table table-bordered table-striped"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    {showSSCInterData ? <>

                        <tbody>
                            <tr>
                                <th>Course</th>
                                <th>Subject 1</th>
                                <th>Subject 2</th>
                                <th>Subject 3</th>
                                <th colSpan={5}>Subject 4</th>
                            </tr>
                            <tr>
                                <td>{showSSCInterData?.inter_course}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_1_name}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_2_name}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }}>{showSSCInterData?.inter_subject_3_name}</td>
                                <td style={{ overflowWrap: "breakWord", whiteSpace: 'unset' }} colSpan={5}>{showSSCInterData?.inter_subject_4_name}</td></tr>

                            <tr>
                                <th>Board</th>
                                <th>Medium</th>
                                <th>2nd Language</th>
                                <th>Year of Passing</th>
                                <th>Hall Ticket No.</th>
                                <th>Total Marks</th> 
                                <th>Marks Secured</th>
                                <th>% of Marks</th>
                                 <th>Did you studied English ?</th>
                            </tr>
                            <tr><td>{showSSCInterData?.inter_board_name}</td>
                                <td>{showSSCInterData?.inter_medium_name}</td>
                                <td>{showSSCInterData?.inter_second_language_name}</td>
                                <td>{showSSCInterData?.inter_year_of_pass}</td>
                                <td>{showSSCInterData?.inter_hall_ticket}</td>
                                <td>{showSSCInterData?.inter_total_marks}</td>
                                <td>{showSSCInterData?.inter_marks_secured}</td>

                                <td>{showSSCInterData?.inter_percentage}</td>
                                <td>{showSSCInterData?.is_english_inter}</td>
                            </tr>

                        </tbody>
                    </>

                        : 'You have not selected any degree'}

                </table>
            </div>
        </div>
    </div>
    </>)
}
export const UGDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<>   <div className='personal-block'>
        {showUgPgPqData?.filter((val) => val.study_type === "UG")?.length > 0 ?
            <div className='personal-block'>
                <div className="personal-head mt-1">
                    <span>Degree or its Equivalent Qualification:</span>
                </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive mb-3">
                        <table className="table table-bordered table-striped"
                            style={{ borderCollapse: 'collapse' }}>
                            {showUgPgPqData?.filter((val) => val.study_type === "UG")?.map((item, i) => {
                                return (
                                    <tbody key={i}>
                                        <tr>
                                            <th colSpan={2}>Course</th><th colSpan={2}>Subject 1</th>
                                            <th colSpan={2}>Subject 2</th>
                                            <th>Subject 3</th><th colSpan={2}>Subject 4</th>
                                        </tr>
                                        <tr><td colSpan={2}>{item?.course_name}</td>
                                            <td colSpan={2}>{item?.subject_1_name}</td>
                                            <td colSpan={2}>{item?.subject_2_name}</td>
                                            <td >{item?.subject_3_name}</td>
                                            <td colSpan={2}>{item?.subject_4_name}</td></tr>
                                        <tr>
                                            <th>University</th>
                                            <th>Medium</th>
                                            <th>2nd Language</th>
                                            <th>Year of Passing</th>
                                            <th>Hall Ticket No.</th>
                                                <th>Total Marks</th>
                                                <th>Marks Secured</th>
                                            <th>% of Marks</th>
                                             <th>Did You Study English?</th>
                                        </tr>
                                        <tr><td>{item?.univ_name}</td>
                                            <td>{item?.medium_name}</td>
                                            <td>{item?.second_language_name}</td>
                                            <td>{item?.year_of_pass}</td>
                                            <td>{item?.hall_ticket}</td>
                                            <td>{item?.total_marks}</td>
                                            <td>{item?.marks_secured}</td>
                                            <td>{item?.percentage}</td>
                                            <td>{item?.is_english_ug}</td>
                                        </tr>
                                    </tbody>
                                )
                            })}
                        </table>
                    </div>
                </div>
            </div>
            : <></>}
    </div>
    </>)
}
export const PGDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<>   <div className='personal-block'>
        {showUgPgPqData?.filter((val) => val.study_type === "PG")?.length > 0 ? <div className='personal-block'>
            <div className="personal-head mt-1">
                <span>Post Graduation</span>
            </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive mb-3" >
                    <table className="table table-bordered table-striped"
                        style={{ borderCollapse: 'collapse', }} role="presentation">

                        {showUgPgPqData?.filter((val) => val.study_type === "PG")?.map((item, i) => {
                            return (
                                <tbody key={i}>
                                    <tr>
                                        <th>Course</th>
                                        <th colSpan={4}> Subject</th>
                                    </tr>
                                    <tr> <td>{item?.course_name}</td>
                                        <td colSpan={4}>{item?.subject_1_name}</td></tr>
                                    <tr>
                                        <th>University</th>
                                        <th>Medium</th>
                                        <th>Year of Passing</th>
                                        <th>Hall Ticket No.</th>
                                        <th>Total Marks</th>
                                        <th>Marks Secured</th>
                                        <th>% of Marks</th>
                                    </tr>
                                    <tr><td>{item?.univ_name}</td>
                                        <td>{item?.medium_name}</td>
                                        <td>{item?.year_of_pass}</td>
                                        <td>{item?.hall_ticket}</td>
                                        <td>{item?.total_marks}</td>
                                        <td>{item?.marks_secured}</td>
                                        <td>{item?.percentage}</td>
                                    </tr>
                                </tbody>

                            )
                        })}

                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>
    </>)
}
export const PQDetails = (props) => {
    const { showUgPgPqData } = props;
    return (<> <div className='personal-block'>
        <div className="personal-head mt-1">
            <span>Professional Qualification</span>
        </div>
        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3" >
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    <thead>
                        <tr>
                            <th>Qualification</th>
                            <th> Methodology 1</th>
                            <th> Methodology 2</th>
                            <th>University</th>
                            <th>Medium</th>
                            <th> Year of Passing</th>
                            <th>Total Marks</th>
                            <th>Marks Secured</th>
                            <th>% of Marks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {showUgPgPqData?.filter((val) => val.study_type === "PQ")?.map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td>{item?.course_name}</td>
                                    <td>{item?.subject_1_name}</td>
                                    <td>{item?.subject_2_name}</td>
                                    <td>{item?.univ_name}</td>
                                    <td>{item?.medium_name}</td>
                                    <td>{item?.year_of_pass}</td>
                                    <td>{item?.total_marks}</td>
                                    <td>{item?.marks_secured}</td>
                                    <td>{item?.percentage}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </>)
}
export const TETDetails = (props) => {
    const { showTETData } = props;
    return (<> <div className='personal-block'>
        {showTETData?.length > 0 ? <div className='personal-block'><div className="personal-head mt-1">
            <span>APTET/CENTRAL TET DETAILS (CTET)</span>
        </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive mb-3">
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                        style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th>Tet Type</th>
                                <th>HallTicket No.</th>
                                <th>Paper</th>
                                <th>Name In TET</th>
                                <th>Year of Passing</th>
                                <th>Marks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showTETData?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item?.tet_type}</td>
                                        <td>{item?.hall_ticket}</td>
                                        <td>{item?.paper_name}</td>
                                        <td>{item?.name_in_tet}</td>
                                        <td>{item?.year_of_pass}</td>
                                        <td>{item?.marks}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>

    </>)
}
export const PrincipalDetails = (props) => {
    const { showData } = props;
    return (<div className='personal-block'>
        {(showData?.is_principal || showData?.is_hm || showData?.is_group_b) && (<div className='mt-2'>
            <div className="personal-head"><span>Experience for the post of principal</span> </div>
            <div className="personal-row mb-2">
                <table className="mb-2">
                    <tbody>
                        {showData?.is_principal && (<tr>
                            <td style={{ fontSize: "13px" }}>&bull;
                                You are holding the post of Principal or Vice-Principal
                                in the recognized senior secondary schools / equivalent
                                institutions dealing with English Medium in the pay scale of Rs.61960-151370 and with a minimum
                                service of 3 years from the date of notification issued.
                            </td>
                        </tr>)}
                        {showData?.is_group_b && (
                            <tr>
                                <td style={{ fontSize: "13px" }}>&bull;
                                    You are holding Group 'B' posts / the post of PGTs (or)
                                    Lecturers in the recognized senior secondary schools /
                                    equivalent institutions dealing with English Medium in the pay scale of Rs.48440-137220 and with a
                                    minimum service of 5 years from the date of notification issued.
                                </td>
                            </tr>)}
                        {showData?.is_hm && (
                            <tr>
                                <td style={{ fontSize: "13px" }}>&bull;
                                    You are Headmasters in the recognized secondary schools /
                                    equivalent institutions dealing with English Medium in the pay scale of Rs.44570-127480 and with a
                                    minimum service of 5 years from the date of notification issued.

                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>)}
    </div>)
}
export const PostDetails = (props) => {
    const { postDataLoadLess } = props;
    return (<div className='personal-block'>
        <div className="personal-head mt-1">
            <span>Posts Details</span>
        </div>

        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3" >
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    <tbody>
                        <tr><th>S.No</th>
                            <th>Post</th>
                            <th>Applied On</th>
                        </tr>
                        {postDataLoadLess.length > 0 ? postDataLoadLess?.map((data, index) => {
                            return (
                                <tr key={index} id={index}>
                                    <td>{index + 1}.</td>
                                    <td>{data?.post_name}</td>
                                    <td>{data?.formatted_time_stamp}</td>
                                </tr>
                            )
                        }) :
                            <tr><td colSpan={4} className='text-center'><b className='text-danger'> *** You have not selected any posts</b></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>)
}

export const PaymentDetails = (props) => {
    const { PaymentData  } = props;
    return (
       <div className='personal-block'>
                <div className="personal-head mt-1">
                    <span>Payment Details:</span>
                </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive mb-3">
                        <table className="table table-bordered table-striped"
                            style={{ borderCollapse: 'collapse', }} role="presentation">

                            {PaymentData ? <>

                                <tbody>
                                     <tr>
                                <th style={{ width: "5%" }}>S.NO</th>
                                <th style={{ width: "15%" }}>Candidate Id</th>
                                <th style={{ width: "25%" }}>Candidate Name</th>
                                <th style={{ width: "15%" }}>Transaction Id</th>
                                <th style={{ width: "15%" }}>CFSS Transaction Id</th>
                                <th style={{ width: "10%" }}>Paid Amount</th>
                                <th style={{ width: "10%" }}>Paid Date</th>
                                <th style={{ width: "10%" }}>Payment Status</th>
                            </tr>

                            {PaymentData?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.candidate_id}</td>
                                    <td>{item.applicant_name}</td>
                                    <td>{item.tpsl_txn_id}</td>
                                    <td>{item.cfss_txn_id}</td>
                                    <td>{item.amount}</td>
                                    <td>{new Date(item.time_stamp).toLocaleString()}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))} </tbody>
                            </>
                              : 'Payment not successful'}
                        </table>
                    </div>
                </div>
            </div>
        )
}
export const ExamCenterDetails = (props) => {
    const { examCenterData } = props;
    return (
        <div className='personal-block'>
            {examCenterData?.length > 0 ? <div className='personal-block'><div className="personal-head mt-1">
                <span>Examination  Center Preferred Places</span>
            </div>
                <div className="personal-row personal-roweducation">
                    <div className="table-responsive mb-3" >
                        <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                            style={{ borderCollapse: 'collapse', }} role="presentation">

                            <tbody>
                                <tr>
                                    <th>Preference Order</th>
                                    <th>Exam Centers</th>
                                </tr>
                                {examCenterData ? examCenterData?.map((item, index) => {
                                    return (
                                        <tr key={index} id={index}>
                                            <td>{item?.preference}.</td>
                                            <td>{item?.district}</td>
                                        </tr>
                                    )
                                }) : 'You have not selected any posts'}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <></>}
        </div>)
}
export const PreferncesDetails = (props) => {
    const { OptionList } = props;
    return (<div className='personal-block'>
        {OptionList?.length > 0 ? <div className='personal-block'><div className="personal-head mt-1">
            <span>Post Preferences</span>
        </div>
            <div className="personal-row personal-roweducation">
                <div className="table-responsive mb-3" >
                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                        style={{ borderCollapse: 'collapse', }} role="presentation">

                        <tbody>
                            <tr>
                                <th>Preference Order</th>
                                <th>Post Name : Management Name @ District</th>
                            </tr>
                            {OptionList ? OptionList?.map((val, i) => {
                                return (
                                    <tr key={val.id} id={i}>
                                        <td className='text-center'>{i + 1}</td>
                                        <td><b><span style={{ color: 'brown', fontFamily: 'Bold italic' }}>
                                            {val.management_name?.split('_')[0]} </span>: {val.management_name?.split('_')[1]}
                                            @ <span style={{ color: 'blue' }}>{val.management_name?.split('_')[2]}</span></b></td>
                                    </tr>
                                )
                            }) : 'You have not selected any posts'}
                        </tbody>
                    </table>
                </div>
            </div>
        </div> : <></>}
    </div>)
}
export default function PrintApplication() {

    const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    const navigate = useNavigate();
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);

    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "DSC- Application Print",
        pageStyle: `
        @media print {
            body {
            -webkit - print - color - adjust: exact;
        print-color-adjust: exact;
        font-size: 12px;
            }
        table {
            width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
        page-break-inside: avoid;
        margin-bottom: 15px !important;
            }
        th, td {
            padding: 6px !important;
        border: 1px solid #ddd !important;
        word-wrap: break-word;
        vertical-align: top;
            }
        th {
            background - color: #f2f2f2 !important;
        font-weight: bold;
                }
        .personal-head span {
            background - color: #ececec !important;
        color: #000 !important;
                    }
        .personal-block{
            page -break-inside: avoid;
                  }
        .personal-head {

            padding: 8px !important;
        margin-top: 15px !important;
        margin-bottom: 10px !important;
        font-weight: bold;
            }
        img {
            max - width: 130px !important;
        max-height: 150px !important;

        margin: 0 auto !important;
            }
        .photo-cell {
            width: 150px !important;
        text-align: center !important;
        vertical-align: middle !important;
            }
        }
        `
    });
    // display: block !important; its is in img{ } in print
    const [showUgPgPqData, setUgPgPqData] = useState([])
    const [showSevenData, setSevenData] = useState([])
    const [showSSCInterData, setSSCInterData] = useState([])
    const [showData, setData] = useState([])

    const [postDataLoadLess, setPostDataLoadLess] = useState([])
    const getpostDataLaodLessFunction = () => {
        let villUrl = config.url.CONTEXT_READ_URL + "candidate-post-details";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data?.status === true) {
                setPostDataLoadLess(response?.data?.data)
            }
            else {
                setPostDataLoadLess([])
            }
        });
    };

     const [PaymentData, setPaymentData] = useState([])
        const getData = () => {
        let apiUrl = config.url.CONTEXT_READ_URL + "payment-invoice-details?tpslTxnId=all";
        CommonAxiosGet(apiUrl).then((res) => {
            if (res?.data?.status === true) {
                setPaymentData(res?.data?.data);
            }
        });
    };
    const [OptionList, SetOptionList] = useState([])
    function SelectedOptionsFunction() {
        let linkurl = config.url.CONTEXT_READ_URL + 'candidate-post-preferences'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data?.status === true) {
                let data_s = response?.data?.data;
                data_s?.forEach((data) => {
                    data.id = `${data?.management_id}999${data?.post_id}`;
                });
                SetOptionList(data_s)
            }
        });
    }
    const [showTETData, setTETData] = useState([])
    const [examCenterData, setExamCenterData] = useState([])
    const getExamDataFunction = () => {
        let villUrl = config.url.CONTEXT_READ_URL + "candidate-exam-center-details";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                setExamCenterData(response.data.data)
            }
            else {
                setExamCenterData([])
            }
        });
    };
    function getStudyData() {
        let Url = config.url.CONTEXT_READ_URL + "candidate-study-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                if (res?.data?.sevenyear_status === true) {
                    setSevenData(res?.data?.sevenyear)
                }
                if (res?.data?.ugpgpq_status === true) {
                    setUgPgPqData(res?.data?.ugpgpq)
                }
                if (res?.data?.sscinter_status === true) {
                    setSSCInterData(res?.data?.sscinter[0])
                }
                if (res?.data?.tet_status === true) {
                    setTETData(res?.data?.tet)
                }
                if (res?.data?.candidatereg_status === true) {
                    setData(res?.data?.candidatereg[0])
                    localStorage.setItem("caste", res?.data?.candidatereg[0]?.certificate_id)
                    const casteId = res?.data?.candidatereg[0]?.certificate_id;
                    if (casteId) {
                        localStorage.setItem("caste", casteId);
                    } else {
                        console.warn("No certificate_id found");
                    }

                }
            }
        })
    }
    useEffect(() => {
        SelectedOptionsFunction()
        getStudyData()
        getExamDataFunction()
        getpostDataLaodLessFunction()
        getData();
    }, [])

    /*******************Header************************************** */

    /*******************Content to be Print************************************** */
    let PrintContent = () =>
        <div ref={componentRef} className='mt-1'>
            <Afterprint />
            <PersonalDetails showData={showData} />
            <SevenYearDetails showData={showData} showSevenData={showSevenData} />
            <SSCDetails showSSCInterData={showSSCInterData} />
            <INTERDetails showSSCInterData={showSSCInterData} />
            <UGDetails showUgPgPqData={showUgPgPqData} />
            <PGDetails showUgPgPqData={showUgPgPqData} />
            <PQDetails showUgPgPqData={showUgPgPqData} />
            <TETDetails showTETData={showTETData} />
            <PrincipalDetails showData={showData} />
            <PostDetails postDataLoadLess={postDataLoadLess} />
            <PaymentDetails PaymentData={PaymentData} />
            <ExamCenterDetails examCenterData={examCenterData} />
            <PreferncesDetails OptionList={OptionList} />

        </div>;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && (event.key === 'p' || event.key === 'P')) {
                event.preventDefault();
                alert('Print function is disabled on this page.Use print button', 'warning')
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (
        <React.Fragment>

            {tabdetails?.latestTab === 4 || postDataLoadLess?.length > 0 ?
                <React.Fragment>
                    {postDataLoadLess?.length > 0 ?
                        <div className='mt-4'><h5>
                            <b > Click Here </b> <FaHandPointRight size={30} />&nbsp;
                            <button className="btn btn-primary" variant="primary" onClick={handleprint}>Print&nbsp;
                                <FaPrint title="Print" style={{ fontSize: '22px' }} />
                            </button>
                        </h5></div> : <><div className="text-center mt-4"></div></>}
                    <PrintContent />

                </React.Fragment>
                : <React.Fragment>
                    <br />
                    <h3 className="text-error mt-4 border p-3 fs-6 w-100">
                        <strong>Dear {loginreducer?.applicant_name},</strong><pre />
                        Your Application is Partially Submitted for {CONTEXT_NAME} RECRUITMENT-{ACADEMIC_YEAR} , Please Complete the Application to View Print.
                        <span>  <i style={{ background: "#2a9d8f" }}
                            className="badge badge-success forgot fw-bold"
                            onClick={() => navigate('/ProfileDetailsWay')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navigate('/ProfileDetailsWay')
                                }
                            }}
                            data-toggle="tooltip" animation="true"
                        > Click Here </i> </span> to complete the application.

                    </h3>

                </React.Fragment>
            }


        </React.Fragment>
    )
}
